import Axios from 'axios'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import './sidebar.css'

const data1 = [
    { name: 'Publication', link: '/cis_publication' },
    { name: 'Research Division', link: '/report' },
    { name: 'Research Clusters', link: '/research/cluster' },
    { name: 'CIS Faculty', link: '/research/faculty' },
    { name: 'CIS Student Theses', link: '/theses' },
]

const data3 = [
    { name: 'Biographies', link: '/biographies' },
    { name: 'Glossary of Terms', link: '/glossary' },
    { name: 'Islamic Finance Periodicals', link: '/periodicals/English/0' },
    { name: 'Financial Institutions in Qatar', link: '/financial_institution' },
    { name: 'Academic Institutions', link: '/academic_institution/page/0' },
]
let data = new Object
class SideMenu extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            menus: []
        }
    }

    componentDidMount = () => {
        
        
        if (this.props.data == 'data2'){
            const data2 = []
            Axios.get(BASE + 'jsonapi/node/page?filter[check][condition][path]=field_front_end_sub_menu&filter[check][condition][operator]=IS NOT NULL&sort=field_sort')
            .then(resp => {
                console.log('menus', resp.data.data)
                this.setState({
                    menus: resp.data.data
                })
            })
            this.state.menus.map(item=>{
                let obj = new Object
                obj.name  = item.attributes.name
                obj.link = '/specialised/' + item.attributes.name
                data2.push(obj)
                console.log('getting',data2)
            })
            if(data2.length)
            this.setState({
                data: data2
            })
        }
            
        else if (this.props.data == 'data1')
            this.setState({
                data: data1
            })
        else
            this.setState({
                data: data3
            })
    }

    render() {
        return (
            <div className='side-menu'>
                <div className='menu-item'>
                    {this.state.data.map((data) => {
                        return <Link style={{ color: data.link == window.location.pathname ? '#000000' : '' }} to={data.link}>{data.name}</Link>

                    })}
                </div>
            </div>
        )
    }
}
export default SideMenu;

